module.exports = __webpack_public_path__ + "static/media/wireframing_02@2x.5092aa1a.png";